//export const API_URL = 'http://localhost:3001';
export const API_URL = 'https://api.pryview.net';
//export const API_URL = 'https://api-dev.pryview.net';
